import React from 'react'
import isEmpty from 'lodash/isEmpty'
import { getTypeId } from 'training-lane-booking-shared/utilities/functions'
import purchasePickedTitleClasses from './PurchasePickedTitle.module.scss'

const PurchasePickedTitle = ({ itemType }) =>
    !isEmpty(itemType) ? (
        <div style={{ color: itemType.color }}>
            <div className={purchasePickedTitleClasses.title}>
                {itemType.id === getTypeId('vs')
                    ? itemType.description.short
                    : itemType.description.peopleShort}
                {' '}
                {itemType.description.shorter}
            </div>
        </div>
    ) : null

export default PurchasePickedTitle
